// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../Configurations/AuthContext";
// import { isPlanExpired } from "./dateUtils";

// export default function KycNotification() {
//   const navigate = useNavigate();
//   const { user } = useAuth();
//   const [dismissed, setDismissed] = useState(false);

//   const planIsExpired = user ? isPlanExpired(user.endDate) : false;
//   const showKYCBanner = user && !user.isKYC && !planIsExpired && !dismissed;

//   if (!showKYCBanner) return null;

//   return (
//     <div
//       style={{
//         backgroundColor: "#fff3cd",
//         borderBottom: "1px solid #ffc107",
//         padding: "8px 24px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//       }}
//     >
//       <div className="d-flex align-items-center gap-2">
//         <i className="ri-error-warning-line fs-5" style={{ color: "#856404" }} />
//         <span style={{ color: "#856404", fontWeight: 500 }}>
//           Complete your KYC to make bookings and access all services.
//         </span>
//       </div>
//       <div className="d-flex align-items-center gap-2">
//         <button
//           className="btn btn-sm"
//           style={{ backgroundColor: "#ffc107", color: "#000", fontWeight: 500 }}
//           onClick={() => navigate("/company-documents")}
//         >
//           Complete KYC
//         </button>
//         <button
//           className="btn btn-sm"
//           style={{
//             background: "none",
//             border: "none",
//             color: "#856404",
//             fontWeight: 700,
//             fontSize: "16px",
//             lineHeight: 1,
//             padding: "0 4px",
//           }}
//           onClick={() => setDismissed(true)}
//           aria-label="Close"
//         >
//           &times;
//         </button>
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Configurations/AuthContext";
import { isPlanExpired } from "./dateUtils";

export default function KycNotification() {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const [kycDismissed, setKycDismissed] = useState(false);
  const [walletDismissed, setWalletDismissed] = useState(false);

  if (!user) return null;

  const planIsExpired = isPlanExpired(user.endDate);
  if (planIsExpired) return null;

  if (!user.isKYC) {
    // If user has dismissed this banner, don't show it
    if (kycDismissed) return null;

    return (
      <div
        style={{
          backgroundColor: "#fff3cd",
          borderBottom: "1px solid #ffc107",
          padding: "8px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="d-flex align-items-center gap-2">
          <i className="ri-error-warning-line fs-5" style={{ color: "#856404" }} />
          <span style={{ color: "#856404", fontWeight: 500 }}>
            Complete your KYC to make bookings and access all services.
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-sm"
            style={{ backgroundColor: "#ffc107", color: "#000", fontWeight: 500 }}
            onClick={() => navigate("/company-documents")}
          >
            Complete KYC
          </button>
          <button
            className="btn btn-sm"
            style={{
              background: "none",
              border: "none",
              color: "#856404",
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: 1,
              padding: "0 4px",
            }}
            onClick={() => setKycDismissed(true)}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
      </div>
    );
  }

  const walletBalanceNum = Number(user.walletBalance) || 0;
  
  if (walletBalanceNum < 5000) {
    // If user has dismissed this banner, don't show it
    if (walletDismissed) return null;

    return (
      <div
        style={{
          backgroundColor: "#f8d7da",
          borderBottom: "1px solid #f5c6cb",
          padding: "8px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="d-flex align-items-center gap-2">
          <i className="ri-wallet-3-line fs-5" style={{ color: "#721c24" }} />
          <span style={{ color: "#721c24", fontWeight: 500 }}>
            Recharge your wallet to get uninterrupted booking services and enjoy seamless bookings.
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-sm"
            style={{ backgroundColor: "#dc3545", color: "#fff", fontWeight: 500 }}
            onClick={() => navigate("/topuprequest")} // Feel free to update the path to your payment page
          >
            Recharge Wallet
          </button>
          <button
            className="btn btn-sm"
            style={{
              background: "none",
              border: "none",
              color: "#721c24",
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: 1,
              padding: "0 4px",
            }}
            onClick={() => setWalletDismissed(true)}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
      </div>
    );
  }

  // If KYC is verified and wallet balance is 5000 or above, show nothing
  return null;
}
